<template>
    <div class="genesis-details">
        <div v-if="!loading" class="content">
            <h1 class="genesis-name">{{poolData.baseProduct}}</h1>
            <div class="cycle-select-row">
                <select v-model="selectedCycle" @change="getGenesisDetails()" class="custom-select form-control billing-cycle-select">
                    <option v-for="cycle in cycles" :selected="cycle.offset == selectedCycle" :value="cycle.offset">{{cycle.description}}</option>
                </select>
            </div>
            <div class="summary-boxes-row">
                <div class="summary-box">
                    <h3>{{summaryNumbers.sumOfRatios}}</h3>
                    <p>Total sum of ratios</p>
                </div>
                <div class="summary-box">
                    <h3>{{summaryNumbers.numberOfSims}}</h3>
                    <p>Total # of SIM's</p>
                </div>
                <div class="summary-box">
                    <h3>{{summaryNumbers.numberOfPlans}}</h3>
                    <p>Total # of Plans</p>
                </div>
                <div class="summary-box">
                    <h3>{{summaryNumbers.roamingMbUsed}}</h3>
                    <p>Total Roaming Used</p>
                </div>
                <div class="summary-box">
                    <h3>{{summaryNumbers.mbLimit}}</h3>
                    <p>Total Domestic Pool Data</p>
                </div>
                <div class="summary-box">
                    <h3>{{summaryNumbers.mbUsed}}</h3>
                    <p>Total Domestic Data Used</p>
                </div>
                <div v-if="summaryNumbers.overage != '0 MB'" class="summary-box overage">
                    <h3>{{summaryNumbers.overage}}</h3>
                    <p>Overage</p>
                </div>
            </div>
            <div class="pools">
                <div class="pool-box">
                    <div v-if="poolData.graphType == 'OVERAGE'" class="data-distribution-graph-box">
                        <h3 class="data-distribution-header">{{poolData.baseProduct}}</h3>
                        <div class="pool-costs">
                            <div v-if="poolData.normalUsage != '0 MB'" class="cost normal-usage">
                                <div class="cost-name">
                                    <div class="dot"></div>
                                    <h6>MB Used</h6>
                                </div>
                                <div class="cost-value">{{poolData.normalUsage}} <span class="inGB" v-if="poolData.normalUsageGB">({{poolData.normalUsageGB}})</span></div>
                            </div>
                            <div class="cost overage-usage">
                                <div class="cost-name">
                                    <div class="dot"></div>
                                    <h6>Overage</h6>
                                </div>
                                <div class="cost-value">{{poolData.overageUsage}} <span class="inGB" v-if="poolData.overageUsageGB">({{poolData.overageUsageGB}})</span></div>
                            </div>
                        </div>
                        <div class="usage-graph">
                            <div v-if="poolData.normalUsage != '0 MB'" :style="'width: ' + poolData.normalUsageWidth + '%'" class="graph-pool normal-data">
                                <span class="amount">{{poolData.normalUsage}} <span class="inGB" v-if="poolData.normalUsageGB">({{poolData.normalUsageGB}})</span></span>
                                <div class="hover-tooltip normal-data">
                                    <div class="leftside-bar"></div>
                                    <div class="right-side">
                                        <h6>MB Used</h6>
                                        <p><span>{{poolData.normalUsage}} <span class="inGB" v-if="poolData.normalUsageGB">({{poolData.normalUsageGB}})</span> / {{poolData.normalUsage}} <span class="inGB" v-if="poolData.normalUsageGB">( {{poolData.normalUsageGB}} )</span></span></p>
                                        <p class="usage-percent">100% Usage</p>
                                    </div>
                                </div>
                            </div>
                            <div :style="'width: ' + poolData.overageWidth + '%'" class="graph-pool overage-data">
                                <span class="amount">{{poolData.overageUsage}} <span class="inGB" v-if="poolData.overageUsageGB">({{poolData.overageUsageGB}})</span></span>
                                <div class="hover-tooltip overage-data">
                                    <div class="leftside-bar"></div>
                                    <div class="right-side">
                                        <h6>Overage</h6>
                                        <p><span>{{poolData.overageUsage}} <span class="inGB" v-if="poolData.overageUsageGB">({{poolData.overageUsageGB}})</span></span></p>
                                        <p class="overage-percent">{{poolData.overagePercentDisplay}}% Usage</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="scale-box">
                            <div :style="'width:' + poolData.normalUsageWidth + '%'" :class="['scale-box-normal', poolData.normalUsageWidth < 20 ? 'reduced-to-two' : '', poolData.normalUsageWidth < 10 ? 'reduced-to-one' : '']">
                                <div class="scale-point">0%</div>
                                <div class="scale-point">25%</div>
                                <div class="scale-point">50%</div>
                                <div class="scale-point">75%</div>
                                <div class="scale-point">100%</div>
                            </div>
                            <div :style="'width:' + poolData.overageWidth + '%'"  class="scale-box-overage">
                                <div class="scale-point">{{poolData.overagePercent}}%</div>
                            </div>
                        </div>
                    </div>

                    <div v-if="poolData.graphType == 'NO_OVERAGE'" class="data-distribution-graph-box">
                        <h3 class="data-distribution-header">{{poolData.baseProduct}}</h3>
                        <div class="pool-costs">
                            <div class="cost normal-usage">
                                <div class="cost-name">
                                    <div class="dot"></div>
                                    <h6>MB Used</h6>
                                </div>
                                <div class="cost-value">{{poolData.used}} <span v-if="poolData.usedGB" class="inGB">( {{poolData.usedGB}} )</span></div>
                            </div>
                            <div class="cost overage-usage">
                                <div class="cost-name">
                                    <div class="dot"></div>
                                    <h6>Overage</h6>
                                </div>
                                <div class="cost-value">0 MB</div>
                            </div>
                        </div>
                        <div class="usage-graph">
                            <div :style="'width: ' + poolData.usedPercent + '%'" class="graph-pool normal-data normal-unused-pool">
                                <span class="amount">{{poolData.used}} <span v-if="poolData.usedGB" class="inGB">( {{poolData.usedGB}} )</span></span>
                                <div class="hover-tooltip normal-data">
                                    <div class="leftside-bar"></div>
                                    <div class="right-side">
                                        <h6>MB Used</h6>
                                        <p><span>{{poolData.used}}</span> <span v-if="poolData.usedGB" class="inGB">( {{poolData.usedGB}} ) / {{poolData.totalDisplay}}</span></p>
                                        <p class="usage-percent">{{poolData.usedPercentDisplay}}% Usage</p>
                                    </div>
                                </div>
                            </div>
                            <div :style="'width: ' + poolData.unusedPercent + '%'" class="graph-pool unused-data normal-unused-pool"></div>
                        </div>
                        <div class="scale-box scale-box-unused">
                            <div class="scale-point">0%</div>
                            <div class="scale-point">25%</div>
                            <div class="scale-point">50%</div>
                            <div class="scale-point">75%</div>
                            <div class="scale-point">100%</div>
                        </div>
                    </div>

                    <div v-if="poolData.graphType == 'NODATA'" class="data-distribution-graph-box">
                        <h3 class="data-distribution-header">{{poolData.baseProduct}}</h3>
                        <div class="pool-costs">
                            <div class="cost normal-usage">
                                <div class="cost-name">
                                    <div class="dot"></div>
                                    <h6>MB Used</h6>
                                </div>
                                <div class="cost-value no-data">N/A</div>
                            </div>
                        </div>
                        <div class="usage-graph">
                            <div class="graph-pool no-data">
                                <span class="amount">N/A</span>
                            </div>
                        </div>
                        <div class="scale-box scale-box-unused">
                            <div class="scale-point">0%</div>
                            <div class="scale-point">25%</div>
                            <div class="scale-point">50%</div>
                            <div class="scale-point">75%</div>
                            <div class="scale-point">100%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="charges">
                <h3 class="charges-header">Charges</h3>
                <div class="charges-box">
                    <div class="charge">
                        <h4 class="value">{{charges.monthlyCharges}}</h4>
                        <h5 class="name">Monthly</h5>
                    </div>
                    <div class="charge">
                        <h4 class="value">{{charges.roamingCharges}}</h4>
                        <h5 class="name">Current Roaming</h5>
                    </div>
                    <div class="charge">
                        <h4 class="value">{{charges.overageCharges}}</h4>
                        <h5 class="name">Current Domestic Overage</h5>
                    </div>
                    <div class="charge">
                        <h4 class="value">{{charges.totalCharges}}</h4>
                        <h5 class="name">Current Total</h5>
                    </div>
                </div>
            </div>

            <div class="plans-using-table-box fts-table-wrapper">
                <h3 class="plans-table-header">
                    Plans using this category
                </h3>
                <div class="fts-table table-responsive-sm">
                    <table class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment table-plans-billing">
                        <thead role="rowgroup">
                        <tr role="row">
                            <th role="columnheader" aria-colindex="1" aria-label="Date">Plans</th>
                            <th role="columnheader" aria-colindex="2" aria-label="Date">Company Name</th>
                            <th role="columnheader" aria-colindex="3" aria-label="Date"># of SIM's in Plan</th>
                            <th role="columnheader" aria-colindex="4" aria-label="Date">Domestic Data Used</th>
                            <th role="columnheader" aria-colindex="5" aria-label="Date">Roaming MB Used</th>
                            <th role="columnheader" aria-colindex="6" aria-label="Date">Sum of ratio</th>
                            <th role="columnheader" aria-colindex="7" aria-label="Date">MRC</th>
                            <th role="columnheader" aria-colindex="8" aria-label="Date">Roaming Charges</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="plan in plansList">
                            <td>{{plan.planName}}</td>
                            <td>{{plan.companyName}}</td>
                            <td>{{plan.noOfSims}}</td>
                            <td>{{plan.domesticMbUsed}}</td>
                            <td>{{plan.roamingMbUsed}}</td>
                            <td>{{plan.sumOfRatios}}</td>
                            <td>{{plan.monthlyCharges}}</td>
                            <td>{{plan.roamingCharges}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="loading-billings" v-else>
            <div class="loading-billings-inner">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>

                <div class="text">
                    Genesis details are processing. Please wait.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import globalStore from "../../variables";
    import Axios from 'axios'
    export default {
        name: "GenesisDetails",
        data() {
            return {
                detailsId: this.$route.params.id,
                poolData: {},
                summaryNumbers: {
                    sumOfRatios: '',
                    numberOfSims: '',
                    numberOfPlans: '',
                    roamingMbUsed: '',
                    mbLimit: '',
                    mbUsed: '',
                    overage: ''
                },
                charges: {
                    monthlyCharges: '',
                    roamingCharges: '',
                    overageCharges: '',
                    totalCharges: ''
                },
                plansList: [],
                loading: true,
                cycles: [],
                selectedCycle: this.$session.get('offset')
            }
        },
        methods: {
            getGenesisDetails() {
                this.loading = true;
                Axios.get( globalStore.data.restApiUrl + '/billing/genesis-base-product-summary/summary-details?offset=' + this.selectedCycle + '&baseProductId=' + this.$session.get('detailsId'))
                    .then(response => {
                        this.plansList = []
                        let plansToParse = response.data.planDetails

                        for (let plan of plansToParse) {
                            let template = {}
                            template.planName = plan.planName
                            template.companyName = plan.companyName
                            template.noOfSims = plan.noOfSims

                            let domesticParsed
                            if (plan.domesticMbUsed > (1024 * 1024)) {
                                domesticParsed = (plan.domesticMbUsed / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                            } else if (plan.domesticMbUsed >= 1024) {
                                domesticParsed = (plan.domesticMbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                            } else {
                                domesticParsed = plan.domesticMbUsed.toLocaleString('en-US', {maximumFractionDigits:2}) + ' MB'
                            }

                            template.domesticMbUsed = domesticParsed

                            let roamingParsed
                            if (plan.roamingMbUsed > (1024 * 1024)) {
                                roamingParsed = (plan.roamingMbUsed / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                            } else if (plan.roamingMbUsed >= 1024) {
                                roamingParsed = (plan.roamingMbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                            } else {
                                roamingParsed = plan.roamingMbUsed.toLocaleString('en-US', {maximumFractionDigits:2}) + ' MB'
                            }

                            template.roamingMbUsed = roamingParsed

                            template.sumOfRatios = plan.sumOfRatios

                            template.monthlyCharges = '$ ' + plan.monthlyCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2})

                            template.roamingCharges = '$ ' + plan.roamingCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2})

                            this.plansList.push(template)
                        }

                        this.charges = {
                            monthlyCharges: '',
                            roamingCharges: '',
                            overageCharges: '',
                            totalCharges: ''
                        }

                        let parsedRoaming
                        let parsedLimit
                        let parsedUsed
                        let parsedOverage

                        if (response.data.roamingMbUsed > (1024 * 1024)) {
                            parsedRoaming = (response.data.roamingMbUsed / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                        } else if (response.data.roamingMbUsed >= 1024) {
                            parsedRoaming = (response.data.roamingMbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                        } else {
                            parsedRoaming = response.data.roamingMbUsed.toLocaleString('en-US', {maximumFractionDigits:2}) + ' MB'
                        }

                        if (response.data.mbLimit > (1024 * 1024)) {
                            parsedLimit = (response.data.mbLimit / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                        } else if (response.data.mbLimit >= 1024) {
                            parsedLimit = (response.data.mbLimit / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                        } else {
                            parsedLimit = response.data.mbLimit.toLocaleString('en-US', {maximumFractionDigits:2}) + ' MB'
                        }

                        if (response.data.mbUsed > (1024 * 1024)) {
                            parsedUsed = (response.data.mbUsed / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                        } else if (response.data.mbUsed >= 1024) {
                            parsedUsed = (response.data.mbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                        } else {
                            parsedUsed = response.data.mbUsed.toLocaleString('en-US', {maximumFractionDigits:2}) + ' MB'
                        }

                        if (response.data.overage > (1024 * 1024)) {
                            parsedOverage = (response.data.overage / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                        } else if (response.data.overage >= 1024) {
                            parsedOverage = (response.data.overage / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                        } else {
                            parsedOverage = response.data.overage.toLocaleString('en-US', {maximumFractionDigits:2}) + ' MB'
                        }

                        this.charges.monthlyCharges = '$ ' + response.data.monthlyCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2})
                        this.charges.roamingCharges = '$ ' + response.data.roamingCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2})
                        this.charges.overageCharges = '$ ' + response.data.overageCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2})
                        this.charges.totalCharges = '$ ' + response.data.totalCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2})



                        this.summaryNumbers = {
                            sumOfRatios: '',
                            numberOfSims: '',
                            numberOfPlans: '',
                            roamingMbUsed: '',
                            mbLimit: '',
                            mbUsed: '',
                            overage: ''
                        }

                        this.summaryNumbers = {
                            sumOfRatios: response.data.sumOfRatios,
                            numberOfSims: response.data.numberOfSims,
                            numberOfPlans: response.data.numberOfPlans,
                            roamingMbUsed: parsedRoaming,
                            mbLimit: parsedLimit,
                            mbUsed: parsedUsed,
                            overage: parsedOverage
                        }

                        let poolData = response.data

                        if (poolData.mbUsed == 0) {
                            poolData.graphType = 'NODATA'
                            this.poolData = poolData
                        } else if (poolData.overage > 0) {
                            this.poolData = this.parseOverageGraph(poolData)
                        } else {
                            this.poolData = this.parseNoOverageGraph(poolData)
                        }

                        this.loading = false;

                        setTimeout(() => {
                            this.fixGraphPools();
                        }, 100)

                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Genesis Details error',
                            text: 'Something wen wrong during getting data of Genesis Details. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            getCycles() {
                Axios.get( globalStore.data.restApiUrl + '/billing-ng/cycles')
                    .then (response => {
                        this.cycles = response.data
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error occured during getting billing cycles.',
                            text: 'Something wen wrong during getting data of billing cycles. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            parseOverageGraph(graphData) {
                let totalMB = graphData.overage + graphData.mbLimit;

                let normalUsage = graphData.mbLimit
                let normalUsageGB
                if (normalUsage > (1024 * 1024)) {
                    normalUsageGB = (normalUsage / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                    normalUsage = (normalUsage / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                } else if (normalUsage > 1024) {
                    normalUsageGB = (normalUsage / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                    normalUsage = (normalUsage).toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                } else {
                    normalUsage = normalUsage.toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                    normalUsageGB = false
                }

                let overageUsage = graphData.overage
                let overageUsageGB
                if (overageUsage > (1024 * 1024)) {
                    overageUsageGB = (overageUsage / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + 'TB'
                    overageUsage = (overageUsage / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + 'GB'
                } else if (overageUsage > 1024) {
                    overageUsageGB = (overageUsage / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + 'GB'
                    overageUsage = overageUsage.toLocaleString('en-US', {maximumFractionDigits:1}) + 'MB'
                } else {
                    overageUsage = overageUsage.toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                    overageUsageGB = false
                }
                let overagePercent
                let overagePercentDisplay
                if (graphData.mbLimit) {
                    overagePercent = Math.round(((graphData.overage + graphData.mbLimit) / graphData.mbLimit) * 100)
                    overagePercentDisplay = overagePercent - 100
                } else {
                    overagePercent = 100
                    overagePercentDisplay = 100
                }
                let normalUsageWidth = Math.round((graphData.mbLimit / totalMB) * 100)
                let overageWidth = 100 - normalUsageWidth

                let roamingValueParsed

                if (graphData.roamingMbUsed > (1024 * 1024)) {
                    roamingValueParsed = (graphData.roamingMbUsed / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                } else if (graphData.roamingMbUsed > 1024) {
                    roamingValueParsed = (graphData.roamingMbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                } else {
                    roamingValueParsed = graphData.roamingMbUsed.toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                }

                let total = {
                    totalMB: totalMB,
                    normalUsage: normalUsage,
                    normalUsageGB: normalUsageGB,
                    overageUsage: overageUsage,
                    overageUsageGB: overageUsageGB,
                    overagePercent: overagePercent,
                    overagePercentDisplay: overagePercentDisplay,
                    normalUsageWidth: normalUsageWidth,
                    overageWidth: overageWidth,
                    graphType: 'OVERAGE',
                    baseProduct: graphData.baseProduct,
                    sumOfRatios: graphData.sumOfRatios,
                    roamingMbUsed: roamingValueParsed,
                    totalCharges: graphData.totalCharges.toLocaleString('en-US', {minimumFractionDigits:2})
                }
                return total
            },
            parseNoOverageGraph(graphData) {
                let totalMB = graphData.mbLimit

                let unused = graphData.mbLimit - graphData.mbUsed
                let unusedPercent = ((graphData.mbLimit - graphData.mbUsed) / graphData.mbLimit) * 100
                let used = graphData.mbUsed
                let usedGB
                if (graphData.mbUsed > (1024 * 1024)) {
                    usedGB = (graphData.mbUsed / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                    used = (graphData.mbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                } else if (graphData.mbUsed > 1024) {
                    usedGB = (graphData.mbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                    used = graphData.mbUsed.toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                } else {
                    used = used.toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                    usedGB = false
                }
                let usedPercent = 100 - unusedPercent;
                let usedPercentDisplay = (100 - unusedPercent).toLocaleString('en-US', {maximumFractionDigits:2})


                let roamingValueParsed

                if (graphData.roamingMbUsed > (1024 * 1024)) {
                    roamingValueParsed = (graphData.roamingMbUsed / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                } else if (graphData.roamingMbUsed > 1024) {
                    roamingValueParsed = (graphData.roamingMbUsed / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                } else {
                    roamingValueParsed = graphData.roamingMbUsed.toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                }

                let totalDisplay
                if (totalMB > (1024 * 1024)) {
                    totalDisplay = (totalMB / (1024 * 1024)).toLocaleString('en-US', {maximumFractionDigits:1}) + ' TB'
                } else if (totalMB > 1024) {
                    totalDisplay = (totalMB / 1024).toLocaleString('en-US', {maximumFractionDigits:1}) + ' GB'
                } else {
                    totalDisplay = totalMB.toLocaleString('en-US', {maximumFractionDigits:1}) + ' MB'
                }

                let total = {
                    totalMB: graphData.mbLimit,
                    totalDisplay: totalDisplay,
                    used: used,
                    usedGB: usedGB,
                    unused: graphData.mbLimit - graphData.mbUsed,
                    unusedPercent: ((graphData.mbLimit - graphData.mbUsed) / graphData.mbLimit) * 100,
                    usedPercent: usedPercent,
                    usedPercentDisplay: usedPercentDisplay,
                    graphType: 'NO_OVERAGE',
                    baseProduct: graphData.baseProduct,
                    sumOfRatios: graphData.sumOfRatios,
                    roamingMbUsed: roamingValueParsed,
                    totalCharges: graphData.totalCharges.toLocaleString('en-US', {minimumFractionDigits:2})
                }
                return total
            },
            fixGraphPools() {
                let pools = document.querySelectorAll('.graph-pool');
                for (let item of pools) {
                    let inside = item.querySelector(".amount")
                    if (inside != null && item.offsetWidth < inside.offsetWidth) {
                        inside.classList.add('hidden');
                    }
                }
            }
        },
        mounted() {
            this.getCycles()
            this.getGenesisDetails()
        }
    }
</script>

<style lang="scss">
    .genesis-details {
        position: relative;
        min-height: 400px;
        padding: 20px;
        margin-bottom: 20px;
        background-color: #fff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        border: 1px solid #c8ced3;

        h1.genesis-name {
            margin: 0 0 20px;
            font-size: 15px;
            font-weight: 700;
        }

        .cycle-select-row {
            margin-bottom: 20px;
            .billing-cycle-select {
                width: 300px;
            }
        }

        .genesis-usage-header {
            font-size: 15px;
            margin: 0 0 22px;
            font-weight: 700;
        }


        .summary-boxes-row {
            display: flex;
            justify-content: space-between;
            .summary-box {
                flex-grow: 1;
                margin-right: 20px;
                padding: 20px;
                background-color: #f2f2f2;
                border: 2px solid #e9ebed;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                &:last-child {
                    margin-right: 0;
                }
                &.overage {
                    background-color: #fc4d4d;
                }
                p {
                    margin: 0;
                }
                h3 {
                    .inGB {
                        font-weight: 400;
                    }
                }
            }
        }

        .periods-box {
            h3 {
                font-size: 14px;
                marign: 0 0 8px;
            }
            .billing-cycle-select {
                width: 240px;
                margin: 0 0 20px;
            }
        }

        .pools {
            .data-distribution-graph-box {
                border: 1px solid #d1d6d9;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                margin: 20px 0;
                padding: 20px;

                .data-distribution-header {
                    font-size: 15px;
                    margin: 0 0 20px 0;
                    font-weight: 700;
                }

                .pool-costs {
                    display: flex;
                    padding-bottom: 20px;
                    .cost {
                        margin-right: 68px;
                        .cost-name {
                            display: flex;
                            align-items: center;
                            .dot {
                                height: 8px;
                                width: 8px;
                                border-radius: 50%;
                                display: inline-block;
                            }
                            h6 {
                                margin: 0 0 0 6px;
                                color: #2F353A;
                                font-weight: 400;
                            }
                        }
                        &.normal-usage {
                            .cost-name {
                                .dot {
                                    background-color: #ec3ac9;
                                }
                            }
                        }
                        &.overage-usage {
                            .cost-name {
                                .dot {
                                    background-color: #fc4d4d;
                                }
                            }
                        }
                        .cost-value {
                            color: #515B65;
                            font-weight: 700;
                        }
                    }
                }

                .usage-graph {
                    display: flex;
                    justify-content: space-between;
                    color: #ffffff;
                    font-weight: 700;
                    .graph-pool {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 0 2px;
                        height: 60px;// 175 suma
                        min-width: 2px;
                        margin: 0 2px;

                        &.no-displayed {
                            min-width: 0;
                        }

                        &.no-data {
                            width: 100%;
                            background-color: #f2f2f2;
                            color: #515B65;
                        }

                        &.normal-unused-pool {
                            margin: 0;
                        }

                        .amount {
                            white-space: nowrap;
                            &.hidden {
                                display: none;
                            }
                            .inGB {
                                font-weight: 400;
                            }
                        }

                        .hover-tooltip {
                            display: none;
                            position: absolute;
                            bottom: 65px;
                            background-color: #fff;
                            border: 1px solid #E1E1E1;
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                            color: #000;
                            padding: 4px 8px 4px 4px;
                            .leftside-bar {
                                width: 8px;
                                margin-right: 8px;
                                -webkit-border-radius: 2px;
                                -moz-border-radius: 2px;
                                border-radius: 2px;
                            }
                            &.normal-data {
                                .leftside-bar {
                                    background-color: #ec3ac9;
                                }
                            }
                            &.overage-data {
                                .leftside-bar {
                                    background-color: #fc4d4d;
                                }
                            }
                            &.unused-data {
                                .leftside-bar {
                                    background-color: #fbd7f4;
                                }
                            }
                            .right-side {
                                h6 {
                                    margin: 0;
                                    white-space: nowrap;
                                }
                                p {
                                    margin: 0;
                                    white-space: nowrap;
                                    font-weight: 400;
                                    span {
                                        font-weight: 700;
                                        &.inGB {
                                            font-weight: 400;
                                        }
                                    }
                                    &.overage-percent {
                                        color: #fc4d4d;
                                    }
                                    &.usage-percent {
                                        color: #ec3ac9;
                                    }
                                }
                            }

                            &::after {
                                content: '';
                                position: absolute;
                                margin: auto;
                                bottom: -8px;
                                left: 0;
                                right: 0;
                                width: 15px;
                                height: 15px;
                                background-color: #ffffff;
                                transform: rotate(45deg);
                                -webkit-transform: rotate(45deg);
                                -moz-transform: rotate(45deg);
                                -o-transform: rotate(45deg);
                                -ms-transform: rotate(45deg);
                                border-right: 1px solid #e1e1e1;
                                border-bottom: 1px solid #e1e1e1;
                            }

                        }

                        &.normal-data {
                            background-color: #ec3ac9; //120
                            &:hover {
                                .hover-tooltip {
                                    display: flex;
                                }
                            }
                        }
                        &.overage-data {
                            background-color: #FC4D4D; // 20
                            &:hover {
                                .hover-tooltip {
                                    display: flex;
                                }
                            }
                        }
                        &.unused-data {
                            background-color: #fbd7f4; // 20
                            &:hover {
                                .hover-tooltip {
                                    display: flex;
                                }
                            }
                        }
                        &:first-child {
                            margin-left: 0;
                        }
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }

                .scale-box {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 10px;
                    .scale-box-normal {
                        display: flex;
                        justify-content: space-between;
                        border-top: 1px solid #d4d4d4;
                        .scale-point {
                            &:last-child {
                                color: #ec3ac9;
                            }
                        }
                        &.reduced-to-two {
                            .scale-point {
                                display: none;
                                &:first-child,
                                &:last-child {
                                    display: initial;
                                }
                            }
                        }
                        &.reduced-to-one {
                            .scale-point {
                                display: none;
                                &:first-child {
                                    display: initial;
                                }
                                &:last-child {
                                    display: none;
                                }
                            }
                        }
                    }
                    .scale-box-overage {
                        display: flex;
                        justify-content: flex-end;
                        border-top: 1px solid #d4d4d4;
                        .scale-point {
                            &:last-child {
                                color: #FC4D4D;
                            }
                        }
                    }
                    &.scale-box-unused {
                        display: flex;
                        justify-content: space-between;
                        border-top: 1px solid #d4d4d4;
                    }
                    .scale-point {
                        position: relative;
                        padding-top: 6px;
                        font-size: 14px;
                        font-weight: 700;
                        &::after {
                            content: '';
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            height: 6px;
                            width: 1px;
                            margin: 0 auto;
                            background-color: #d4d4d4;
                        }
                        &:first-child {
                            &::after {
                                right: 100%;
                            }
                        }
                        &:last-child {
                            &::after {
                                left: 100%;
                            }
                        }
                    }
                }

                .pool-amounts {
                    display: flex;
                    justify-content: space-between;
                    padding: 20px 0 0;
                    .left-side {
                        display: flex;
                        align-items: center;
                        .red-arrow {
                            font-size: 20px;
                            &::before {
                                color: #ff0000;
                            }
                        }
                        .blue-arrow {
                            font-size: 20px;
                            &::before {
                                color: #0088ff;
                            }
                        }
                        .green-arrow {
                            font-size: 20px;
                            &::before {
                                color: #55CD6C;
                            }
                        }
                        h5 {
                            margin: 0 0 0 6px;
                            font-size: 14px;
                            font-weight: 400;
                        }
                    }
                    .right-side {
                        display: flex;
                        h5 {
                            margin: 0 0 0 40px;
                            font-size: 14px;
                            font-weight: 400;
                            span {
                                &.amount {
                                    font-weight: 700;
                                }
                                &.warning {
                                    color: #FC4D4D;
                                }
                                &.inGB {
                                    font-weight: 400;
                                }
                            }
                        }
                    }
                }
                .graph-bottom-bar {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 20px -20px -20px;
                    padding: 20px;
                    background-color: #f5f5f5;
                    .left-side {
                        display: flex;
                        .ratio-box,
                        .roaming-box,
                        .total-box {
                            display: flex;
                            flex-direction: column;
                            margin-right: 80px;
                            color: #515B65;
                            .value {
                                font-weight: 700;
                            }
                            .name {}
                        }
                    }
                    .right-side {
                        a {
                            font-size: 14px;
                            color: #0088FF;
                            font-weight: 700;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .loading-billings {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            background-color: rgba(255, 255, 255, 0.7);

            .loading-billings-inner {
                display: flex;
                justify-content: center;
                align-items: center;
                align-content: center;
                flex-direction: column;
            }

            .sk-wave {
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }
        }

        .charges {
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            .charges-header {
                font-size: 15px;
                margin: 20px;
                font-weight: 700;
            }
            .charges-box {
                display: flex;
                margin: 0 20px 20px;
                .charge {
                    color: #515B65;
                    margin-right: 120px;
                    .value {
                        margin: 0 0 8px;
                        font-size: 20px;
                        font-weight: 700;
                    }
                    .name {
                        margin: 0;
                        font-size: 14px;
                        font-weight: 400;
                    }
                }
            }
        }

        .plans-using-table-box {
            margin: 20px 0;
            padding-bottom: 0;
            .plans-table-header {
                margin: 20px 20px 0;
                font-size: 15px;
                font-weight: 700;
            }
            .table-plans-billing {
                tr {
                    &:last-child {
                        td {
                            border-bottom: none;
                        }
                    }
                }
            }
        }
    }

    .dark-theme {
        .genesis-details {
            background-color: #3a4149;
            border-color: #1a1c1d;
            color: #fff;

            .cycle-select-row {
                .billing-cycle-select {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                    color: #fff;
                }
            }

            .summary-boxes-row {
                .summary-box {
                    background-color: #343a41;
                    border-color: #1a1c1d;
                }
            }

            .pools {
                .data-distribution-graph-box {
                    border-color: #1a1c1d;
                    .pool-costs {
                        .cost {
                            .cost-name {
                                h6 {
                                    color: #fff;
                                }
                            }
                            .cost-value {
                                color: #fff;
                            }
                        }
                    }
                    .scale-box {
                        border-color: #1a1c1d;

                        .scale-box-overage {
                            border-color: #1a1c1d;
                        }

                        .scale-point {
                            &:after {
                                background-color: #1a1c1d;
                            }
                        }
                    }
                }
            }

            .charges {
                border-color: #1a1c1d;
                .value,
                .name {
                    color: #fff;
                }
            }

            .fts-table-wrapper {
                border: 0;
            }

            .loading-billings {
                background-color: rgba(0, 0, 0, 0.4);
            }
        }
    }
</style>
